export default __webpack_public_path__ + "static/media/mockup15.520687f3.jpg";